import React from "react";
import Subscription from "../../Components/OrganizationSettings/Subscription";
import OrganizationSubscriptionProvider from "../../Context/OrganizationSubscription/OrganizationSubscriptionContext";
import NoAccessComponent from "../../Components/Shared/Error/NoAccess";

const WorkspaceSubscriptionPage = ({ organization, user, role }) => {
    const authorized = role.roleType === 'Owner' || role.roleType === 'Administrator';
    if (!authorized) {
        return <NoAccessComponent />;
    }
    return (
        <OrganizationSubscriptionProvider>
            <Subscription
                organization={organization}
                user={user}
                showInIframe={true}
            />
        </OrganizationSubscriptionProvider>
    );
};

export default WorkspaceSubscriptionPage; 